/*
 * @Description: 
 * @Author: 李方强
 * @Date: 2019-07-25 21:35:58
 * @LastEditTime: 2021-11-17 10:09:18
 * @LastEditors: lkz
 */
/*
 本文件用于定义与API接口服务的代码
 只允许导出接口方法，不允许导出其它非接口方法的功能
 */
import * as httpAgent from 'utils/http'
import link from '../../../../utils/link/link'

export function isExistReturnByOrderId(params, options) {
  if (document.domain === link.domain) { // 本地調試则不需要代理
    return httpAgent.GET('/refundadmin/butian/compensate/isExistReturnByOrderId.json', params, options)
  }
  return httpAgent.GET(`//${link.getlink().refundUrl}/butian/compensate/isExistReturnByOrderId.json`, params, options)
}

export function getAllCompensateType(params, options) {
  if (document.domain === link.domain) { // 本地調試则不需要代理
    return httpAgent.GET('/refundadmin/butian/compensate/getAllCompensateType.json', params, options)
  }
  return httpAgent.GET(`//${link.getlink().refundUrl}/butian/compensate/getAllCompensateType.json`, params, options)
}

export function getCompensateWuliu(params, options) {
  if (document.domain === link.domain) { // 本地調試则不需要代理
    return httpAgent.GET('/refundadmin/butian/compensate/getCompensateWuliu.json', params, options)
  }
  return httpAgent.GET(`//${link.getlink().refundUrl}/butian/compensate/getCompensateWuliu.json`, params, options)
}

export function createCompensate(params, options) {
  if (document.domain === link.domain) { // 本地調試则不需要代理
    return httpAgent.POST('/refundadmin/butian/compensate/createCompensate.json', params, options)
  }
  return httpAgent.POST(`//${link.getlink().refundUrl}/butian/compensate/createCompensate.json`, params, options)
}
// /***
//  * 查询售后商品集合
//  * **/
export function returndetailBtJson(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/xinyun/refund/returndetailBtJson.json', params, options)
}

// /***
//  * 查询补偿商品集合
//  * **/
export function getCreateCompensateInfo(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/xinyun/compensate/getCreateCompensateInfo.json', params, options)
}
/*
 * 根据TU获取TU的SKU集合
 */
export function getTUItemByTU(params, options) {
  return httpAgent.GET('/yunjixinyunadmin/xinyun/compensate/getTUItemByTU.json', params, options)
}
/*
 * 补偿详情
 */
export function getSimpleCompensateDetailInfoById(params, options) {
  if (document.domain === link.domain) {
    return httpAgent.GET('/refundadmin/admin/getSimpleCompensateDetailInfoById.json', params, options)
  }
  return httpAgent.GET(`//${link.getlink().refundUrl}/admin/getSimpleCompensateDetailInfoById.json`, params, options)
}

// /***
//  * 售后申请页面金额、类型、数量
//  * **/
export function toRefundCommonView(params, options) {
  if (document.domain === link.domain) { // 本地調試则不需要代理
    return httpAgent.POST('/refundadmin/butian/refund/v3/toRefundCommonView.json', params, options)
  }
  return httpAgent.POST(`//${link.getlink().refundUrl}/butian/refund/v3/toRefundCommonView.json`, params, options)
}

// /***
//  * 售后提交申请
//  * **/
export function refundCommonApply(params, options) {
  if (document.domain === link.domain) { // 本地調試则不需要代理
    return httpAgent.POST('/refundadmin/butian/refund/v3/refundCommonApply.json', params, options)
  }
  return httpAgent.POST(`//${link.getlink().refundUrl}/butian/refund/v3/refundCommonApply.json`, params, options)
}

// /***
//  * 根据扣减金额、数量查询
//  * **/
export function getRefundCommonViewMoney(params, options) {
  if (document.domain === link.domain) { // 本地調試则不需要代理
    return httpAgent.POST('/refundadmin/butian/refund/v3/getRefundCommonViewMoney.json', params, options)
  }
  return httpAgent.POST(`//${link.getlink().refundUrl}/butian/refund/v3/getRefundCommonViewMoney.json`, params, options)
}

// /***
//  * 省市区查询接口
//  * **/
export function getAddress(params, options) {
  if (document.domain === link.domain) { // 本地調試则不需要代理
    return httpAgent.GET('/refundadmin/butian/refund/getCascadeAddress.json', params, options)
  }
  return httpAgent.GET(`//${link.getlink().refundUrl}/butian/refund/getCascadeAddress.json`, params, options)
}

// /***
//  * 新版申请补偿-获取补偿列表
//  * **/
export function preViewCompensateOrderItem(params, options) {
  if (document.domain === link.domain) { // 本地調試则不需要代理
    return httpAgent.POST('/refundadmin/admin/compensateV2/preViewCompensateOrderItem', params, options)
  }
  return httpAgent.POST(`//${link.getlink().refundUrl}/admin/compensateV2/preViewCompensateOrderItem`, params, options)
}

// /***
//  * 新版申请补偿-获取补偿原因
//  * **/
export function preViewScenes(params, options) {
  if (document.domain === link.domain) { // 本地調試则不需要代理
    return httpAgent.POST('/refundadmin/admin/compensateV2/preViewScenes', params, options)
  }
  return httpAgent.POST(`//${link.getlink().refundUrl}/admin/compensateV2/preViewScenes`, params, options)
}

// /***
//  * 新版申请补偿-申请补偿
//  * **/
export function compensateApply(params, options) {
  if (document.domain === link.domain) { // 本地調試则不需要代理
    return httpAgent.POST('/refundadmin/admin/compensateV2/compensateApply', params, options)
  }
  return httpAgent.POST(`//${link.getlink().refundUrl}/admin/compensateV2/compensateApply`, params, options)
}

// /***
//  * 新版申请补偿-申请补偿显示字段
//  * **/
export function preViewTemplate(params, options) {
  if (document.domain === link.domain) { // 本地調試则不需要代理
    return httpAgent.POST('/refundadmin/admin/compensateV2/preViewTemplate', params, options)
  }
  return httpAgent.POST(`//${link.getlink().refundUrl}/admin/compensateV2/preViewTemplate`, params, options)
}

// /***
//  * 新版申请补偿-申请补偿计算金额
//  * **/
export function compensateMoneyCalculate(params, options) {
  if (document.domain === link.domain) { // 本地調試则不需要代理
    return httpAgent.POST('/refundadmin/admin/compensateV2/compensateMoneyCalculate', params, options)
  }
  return httpAgent.POST(`//${link.getlink().refundUrl}/admin/compensateV2/compensateMoneyCalculate`, params, options)
}

// /***
//  * 新版申请补偿-补偿详情
//  * **/
export function queryCompensateInfo(compensateNo, params, options) {
  if (document.domain === link.domain) { // 本地調試则不需要代理
    return httpAgent.GET(`/refundadmin/admin/compensateV2/queryCompensateInfo/${compensateNo}`, params, options)
  }
  return httpAgent.GET(`//${link.getlink().refundUrl}/admin/compensateV2/queryCompensateInfo/${compensateNo}`, params, options)
}

// /***
//  * 新版申请补偿-查看原因
//  * **/
export function checkCompensateRule(params, options) {
  if (document.domain === link.domain) { // 本地調試则不需要代理
    return httpAgent.POST('/refundadmin/admin/compensateV2/checkCompensateRule.json', params, options)
  }
  return httpAgent.POST(`//${link.getlink().refundUrl}/admin/compensateV2/checkCompensateRule.json`, params, options)
}

/*
 * 内部价保差价计算
 */
export function priceGuaranteeToolCalc(params, options) {
  if (document.domain === link.domain) {
    return httpAgent.POST('/refundadmin/admin/compensateV2/priceGuaranteeToolCalc.json', params, options)
  }
  return httpAgent.POST(`//${link.getlink().refundUrl}/admin/compensateV2/priceGuaranteeToolCalc.json`, params, options)
}

// /***
//  * 判断是否同图的接口
//  * **/
export function getImgRisk(params, options) {
  if (document.domain === link.domain) {
    return httpAgent.POST('/refundadmin/butian/risk/getImgRisk.json', params, options)
  }
  return httpAgent.GET(`//${link.getlink().refundUrl}/butian/risk/getImgRisk.json`, params, options)
}


// /***
//  * 补偿申请自动填充
//  * **/
export function getCompensateApplyAutoFillPage(params, options) {
  if (document.domain === link.domain) {
    return httpAgent.POST('/refundadmin/admin/compensateV2/getCompensateApplyAutoFillPage', params, options)
  }
  return httpAgent.POST(`//${link.getlink().refundUrl}/admin/compensateV2/getCompensateApplyAutoFillPage`, params, options)
}
